import getDate from "../../helpers/getDate";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { getStatisticAll,getChartInfo } from "../../redux/actions/statistic";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const CustomTooltip = ({ active, payload, label ,external,year='' }) => {
  const isVisible = active && payload && payload.length;
  return (
    <div className="custom-tooltip" style={{ visibility: isVisible ? 'visible' : 'hidden' }}>
      {isVisible && (
        <>
        <p className="chartToolTip">
          {external
            ? `${external} за ${
                label.replace(/\s\d{2}/, '')
              } ${payload[0].payload.year}: ${payload[0].value}`
            : `Користувачів за ${
                label.replace(/\s\d{2}/, '')
              } ${payload[0].payload.year}: ${payload[0].value}`
          }
        </p>          {/* <p className="chartToolTip">{external?`${external}: ${payload[0].value}`:`Користувачів: ${payload[0].value}`}</p> */}
        </>
        )}
    </div>
  );
};


const Statistic =()=>{
    const dispatch = useDispatch();
    const [ready, setReady] = useState(false);
    const [form, setForm] = useState({});
    const [formMonth, setFormMonth] = useState([]);
    

    const initFunc = () => {
        dispatch(getStatisticAll()).then(res=>{
            setForm(res);
            setReady(true);
        })
    }
    const getChart = () => {
        dispatch(getChartInfo()).then(res=>{
            const formatted = res.map((el, index, arr) => {
              const year = getDate(el.date, 'yyyy', ' ');
              const month = getDate(el.date, 'mmmm', ' ');

              const prevYear = index > 0
                  ? getDate(arr[index - 1].date, 'yyyy', ' ')
                  : null;

              return {
                  ...el,
                  year,
                  date: prevYear === year
                      ? month
                      : `${month} ${year.slice(2)}`
              };
            });
            setFormMonth(formatted);
        })
    }
    useEffect(() => {
        if(!ready){
            initFunc();
            getChart();
        }
        
    }, [ready]);

    return(
    <>
        <div className="statisticHeader">
            Статистичні дані активностей користувачів сервісу “Активні Парки” станом на  <span style={{fontWeight:'bold'}}>{getDate(new Date(),'dd/mmmm/yyyy',' ')}</span>
        </div>
       
       <div style={{ width: '100%' }}>
        <h4>Унікальних користувачів заходили в додаток</h4>
        <ResponsiveContainer width="100%" height={200}>
          <AreaChart
            width={500}
            height={200}
            data={formMonth}
            syncId="anyId"
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
             <Tooltip content={CustomTooltip} />
            <Area type="monotone" dataKey="app_users" stroke="#004185" fill="#004185" />
          </AreaChart>
        </ResponsiveContainer>
        
        <h4>Унікальних користувачів долучилися до клубів</h4>
        <ResponsiveContainer width="100%" height={200}>
          <AreaChart
            width={500}
            height={200}
            data={formMonth}
            syncId="anyId"
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip content={CustomTooltip} />
            <Area type="monotone" dataKey="club_users" stroke="#7B1D5F" fill="#7B1D5F" />
          </AreaChart>
        </ResponsiveContainer>

        <h4>Кількість нових клубів</h4>
        <ResponsiveContainer width="100%" height={200}>
          <AreaChart
            width={500}
            height={200}
            data={formMonth}
            syncId="anyId"
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip content={<CustomTooltip external='Клубів' />} />
            <Area type="monotone" dataKey="clubs" stroke="#CBDB2A" fill="#CBDB2A" />
          </AreaChart>
        </ResponsiveContainer>

        <h4>Унікальних користувачів долучилися до заходів</h4>
        <ResponsiveContainer width="100%" height={200}>
          <AreaChart
            width={500}
            height={200}
            data={formMonth}
            syncId="anyId"
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
             <Tooltip content={CustomTooltip} />
            <Area type="monotone" dataKey="event_users" stroke="#FEC20E" fill="#FEC20E" />
          </AreaChart>
        </ResponsiveContainer>

        <h4>Унікальних користувачів проводили тренування</h4>
        <ResponsiveContainer width="100%" height={200}>
          <AreaChart
            width={500}
            height={200}
            data={formMonth}
            syncId="anyId"
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
             <Tooltip content={CustomTooltip} />
            <Area type="monotone" dataKey="trainers" stroke="#004185" fill="#004185" />
          </AreaChart>
        </ResponsiveContainer>

        <h4>Кількість тренувань</h4>
        <ResponsiveContainer width="100%" height={200}>
          <AreaChart
            width={500}
            height={200}
            data={formMonth}
            syncId="anyId"
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip content={<CustomTooltip external='Тренувань' />} />
            <Area type="monotone" dataKey="activities" stroke="#7B1D5F" fill="#7B1D5F" />
          </AreaChart>
        </ResponsiveContainer>

        <h4>Зареєстровано нових користувачів</h4>
        <ResponsiveContainer width="100%" height={200}>
          <AreaChart
            width={500}
            height={200}
            data={formMonth}
            syncId="anyId"
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
             <Tooltip content={CustomTooltip} />
            <Area type="monotone" dataKey="new_users" stroke="#CBDB2A" fill="#CBDB2A" />
          </AreaChart>
        </ResponsiveContainer>

        <h4>Всього заходів</h4>
        <ResponsiveContainer width="100%" height={200}>
          <AreaChart
            width={500}
            height={200}
            data={formMonth}
            syncId="anyId"
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip content={<CustomTooltip external='Заходів' />} />
            <Area type="monotone" dataKey="events" stroke="#FEC20E" fill="#FEC20E" />
          </AreaChart>
        </ResponsiveContainer>

        <h4>Всього учасників</h4>
        <ResponsiveContainer width="100%" height={200}>
          <AreaChart
            width={500}
            height={200}
            data={formMonth}
            syncId="anyId"
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip content={<CustomTooltip external='Учасників' />} />
            <Area type="monotone" dataKey="participants" stroke="#004185" fill="#004185" />
          </AreaChart>
        </ResponsiveContainer>
      </div>

       {ready?<div className="stats-container">
            <table className="stats-table">
                <thead>
                <tr>
                    <th rowSpan="2" className="num-col">№</th>
                    <th rowSpan="2" className="name-col">Назва</th>
                    <th colSpan="3">Дані на {getDate(new Date(),'dd/mmmm/yyyy',' ')}</th>
                </tr>
                <tr>
                    <th>За весь час</th>
                    <th>За тиждень</th>
                    <th>За 28 днів</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>1</td>
                    <td>Унікальних користувачів заходили в додаток</td>
                    <td>{form.app_users_all}</td>
                    <td>{form.app_users_7d}</td>
                    <td>{form.app_users_28d}</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>Унікальних користувачів долучилися до клубів</td>
                    <td>{form.club_users_all}</td>
                    <td>{form.club_users_7d}</td>
                    <td>{form.club_users_28d}</td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>Кількість клубів</td>
                    <td>{form.clubs_all}</td>
                    <td>{form.clubs_7d}</td>
                    <td>{form.clubs_28d}</td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>Унікальних користувачів долучилися до заходів</td>
                    <td>{form.event_users_all}</td>
                    <td>{form.event_users_7d}</td>
                    <td>{form.event_users_28d}</td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>Унікальних користувачів проводили тренування</td>
                    <td>{form.trainers_all}</td>
                    <td>{form.trainers_7d}</td>
                    <td>{form.trainers_28d}</td>
                </tr>
                <tr>
                    <td>6</td>
                    <td>Кількість тренувань</td>
                    <td>{form.activities_all}</td>
                    <td>{form.activities_7d}</td>
                    <td>{form.activities_28d}</td>
                </tr>
                <tr>
                    <td>7</td>
                    <td>Зареєстровано нових користувачів</td>
                    <td>{form.new_users_all}</td>
                    <td>{form.new_users_7d}</td>
                    <td>{form.new_users_28d}</td>
                </tr>
                <tr>
                    <td>8</td>
                    <td>Завантажень (Android)</td>
                    <td>34 000</td>
                    <td>614</td>
                    <td>1 791</td>
                </tr>
                <tr>
                    <td>9</td>
                    <td>Завантажень (iOS)</td>
                    <td>23 700</td>
                    <td>359</td>
                    <td>1 280</td>
                </tr>
                <tr>
                    <td>10</td>
                    <td>Всього завантажень (всі ОС)</td>
                    <td>{34000+23700}</td>
                    <td>{614+359}</td>
                    <td>{1791+1280}</td>
                </tr>
                <tr>
                    <td>11</td>
                    <td>Всього заходів</td>
                    <td>{form.events_all}</td>
                    <td>{form.events_7d}</td>
                    <td>{form.events_28d}</td>
                </tr>
                <tr>
                    <td>12</td>
                    <td>Всього учасників</td>
                    <td>{form.participants_all}</td>
                    <td>{form.participants_7d}</td>
                    <td>{form.participants_28d}</td>
                </tr>
                </tbody>
            </table>
        </div>:
        <div className="loading-container">
            <h2 className="loading-text">
                Триває завантаження статистичних даних. Очікуйте
            </h2>
        </div>
        }
    </>)

}


export default Statistic;